import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import { success } from 'plugins/toastr';
import { fetchTipIfNeeded, saveTip } from 'tip/actions/tip';
import PageLoader from 'common/components/PageLoader';
import ResourceCard from 'common/components/ResourceCard';
import YoutubeVideo from 'common/components/YoutubeVideo';
import TipDetailHeader from 'tip/components/TipDetailHeader';
import TipForm from 'tip/components/TipForm';

const ReceiveError = () => (
  <div className="ui negative message">
    <div className="header">Erreur de chargement</div>
    <p>Une erreur est survenue pendant le chargement de l'astuce technique.</p>
  </div>
);

const SaveError = () => (
  <div className="ui negative message">
    <div className="header">Erreur de sauvegarde</div>
    <p>Une erreur est survenue pendant la sauvegarde de l'astuce technique.</p>
  </div>
);

const mapStateToProps = state => {
  const { tip } = state.tips;
  const { tip: current, ...rest } = tip;

  return {
    current,
    ...rest,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchTip: () => dispatch(fetchTipIfNeeded(ownProps.route.tip)),
  saveTip: (page, fields) =>
    dispatch(saveTip(ownProps.route.tip, page, fields)),
});
class CoreLayout extends React.Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    isFetching: PropTypes.bool,
    receiveError: PropTypes.object,
    saveError: PropTypes.object,
    current: PropTypes.object,
    route: PropTypes.object.isRequired,
    fetchTip: PropTypes.func.isRequired,
    saveTip: PropTypes.func.isRequired,
  };

  static contextTypes = {
    data: PropTypes.object.isRequired,
  };

  constructor(props, context) {
    super(props, context);

    this.page = context.data.page;

    this.onSubmitTip = this.onSubmitTip.bind(this);
    this.onSaveTip = this.onSaveTip.bind(this);
  }

  componentWillMount() {
    this.props.fetchTip();
  }

  onSubmitTip(fields) {
    const { image, video } = this.refs;

    this.props
      .saveTip(this.page, {
        image: image.getResource(),
        image_id: image.getValue(),
        video: video.getValue(),
        ...fields,
      })
      .then(() => success('Astuce technique mise à jour avec succès'));
  }

  onSaveTip() {
    // Submitting manually
    this.refs.form.submit();
  }

  render() {
    const {
      current,
      isFetching,
      receiveError,
      saveError,
      children,
    } = this.props;

    if (receiveError) {
      return <ReceiveError />;
    }

    if (saveError) {
      return <SaveError />;
    }

    if (isFetching || !current) {
      return <PageLoader title={"Chargement de l'astuce technique"} />;
    }

    const video = current.video ? current.video.original : null;

    return (
      <div>
        <TipDetailHeader tip={current} page={this.page} save={this.onSaveTip} />
        <div className="ui bottom attached segment">
          <div className="ui grid">
            <div className="four wide column">
              <ResourceCard
                ref="image"
                name="image"
                title="Image"
                resource={current.image}
              />
            </div>
            <div className="twelve wide column">
              <TipForm ref="form" onSubmit={this.onSubmitTip} />
            </div>
          </div>
          <div className="ui divider" />
          <form className="ui form">
            <YoutubeVideo
              ref="video"
              name="video_url"
              title="URL vidéo Youtube"
              value={video}
            />
          </form>
        </div>
        {children}
      </div>
    );
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), pure)(
  CoreLayout
);



// WEBPACK FOOTER //
// ./src/modules/tip/layouts/CoreLayout.js